module.exports = __webpack_public_path__ + "static/media/Tynamo_gaussian2.86709ff8.png";